const EducationDetails = ({ data,edu_attachment }) => (
  <div style={{marginTop:"60px"}}>
    <p style={{ 
            textAlign: 'center',
            backgroundColor: "#cb2b14",
            border: "1px solid",
            margin: "5px 0px",
            color: "white", }}>Education details</p>
    <div className="bank-details-table">
      <table style={{ width: '100%',fontSize:'10px' }}>
        <thead style={{ textAlign: 'center' }}>
          <tr>
            <th style={{ border: '1px solid black', borderCollapse: 'collapse' }}>Exam Name</th>
            <th style={{ border: '1px solid black', borderCollapse: 'collapse' }}>Year</th>
            <th style={{ border: '1px solid black', borderCollapse: 'collapse' }}>Roll No.</th>
            <th style={{ border: '1px solid black', borderCollapse: 'collapse' }}>Board / Univ.</th>
            <th style={{ border: '1px solid black', borderCollapse: 'collapse' }}>School/College</th>
            {/* <th style={{ border: '1px solid black', borderCollapse: 'collapse' }}>Subjects</th> */}
            <th style={{ border: '1px solid black', borderCollapse: 'collapse' }}>Obtained Marks</th>
            <th style={{ border: '1px solid black', borderCollapse: 'collapse' }}>Max. Marks</th>
            <th style={{ border: '1px solid black', borderCollapse: 'collapse' }}>Percentage</th>
          </tr>
        </thead>
        <tbody>
          <tr style={{ textAlign: 'center' }}>
            <td style={{ border: '1px solid black', borderCollapse: 'collapse' }}>High School</td>
            <td style={{ border: '1px solid black', borderCollapse: 'collapse' }}>{data.highschool_year}</td>
            <td style={{ border: '1px solid black', borderCollapse: 'collapse' }}>{data.highschool_roll}</td>
            <td style={{ border: '1px solid black', borderCollapse: 'collapse' }}>{data.highschool_board}</td>
            <td style={{ border: '1px solid black', borderCollapse: 'collapse' }}>{data.highschool_name}</td>
            {/* <td style={{ border: '1px solid black', borderCollapse: 'collapse' }}>{data.highschool_subject}</td> */}
            <td style={{ border: '1px solid black', borderCollapse: 'collapse' }}>{data.highschool_obtmarks}</td>
            <td style={{ border: '1px solid black', borderCollapse: 'collapse' }}>{data.highschool_maxmarks}</td>
            <td style={{ border: '1px solid black', borderCollapse: 'collapse' }}>{data.highschool_percentage}</td>
          </tr>
          <tr style={{ textAlign: 'center' }}>
            <td style={{ border: '1px solid black', borderCollapse: 'collapse' }}>Intermediate</td>
            <td style={{ border: '1px solid black', borderCollapse: 'collapse' }}>{data.i_year}</td>
            <td style={{ border: '1px solid black', borderCollapse: 'collapse' }}>{data.i_roll}</td>
            <td style={{ border: '1px solid black', borderCollapse: 'collapse' }}>{data.i_board}</td>
            <td style={{ border: '1px solid black', borderCollapse: 'collapse' }}>{data.i_name}</td>
            {/* <td style={{ border: '1px solid black', borderCollapse: 'collapse' }}>{data.i_subject}</td> */}
            <td style={{ border: '1px solid black', borderCollapse: 'collapse' }}>{data.i_obtmarks}</td>
            <td style={{ border: '1px solid black', borderCollapse: 'collapse' }}>{data.i_maxmarks}</td>
            <td style={{ border: '1px solid black', borderCollapse: 'collapse' }}>{data.i_percentage}</td>
          </tr>
         
     {!data.course.includes("Bache") && <tr style={{ textAlign: 'center' }}>
            <td style={{ border: '1px solid black', borderCollapse: 'collapse' }}>UG</td>
            <td style={{ border: '1px solid black', borderCollapse: 'collapse' }}>{data.ug_year}</td>
            <td style={{ border: '1px solid black', borderCollapse: 'collapse' }}>{data.ug_roll}</td>
            <td style={{ border: '1px solid black', borderCollapse: 'collapse' }}>{data.ug_board}</td>
            <td style={{ border: '1px solid black', borderCollapse: 'collapse' }}>{data.ug_name}</td>
            {/* <td style={{ border: '1px solid black', borderCollapse: 'collapse' }}>{data.i_subject}</td> */}
            <td style={{ border: '1px solid black', borderCollapse: 'collapse' }}>{data.ug_obtmarks}</td>
            <td style={{ border: '1px solid black', borderCollapse: 'collapse' }}>{data.ug_maxmarks}</td>
            <td style={{ border: '1px solid black', borderCollapse: 'collapse' }}>{data.ug_percentage}</td>
          </tr>}
 
        
         <tr style={{ textAlign: 'center' }}>
            <td style={{ border: '1px solid black', borderCollapse: 'collapse' }}>Other</td>
            <td style={{ border: '1px solid black', borderCollapse: 'collapse' }}>{data.other_year}</td>
            <td style={{ border: '1px solid black', borderCollapse: 'collapse' }}>{data.other_roll}</td>
            <td style={{ border: '1px solid black', borderCollapse: 'collapse' }}>{data.other_board}</td>
            <td style={{ border: '1px solid black', borderCollapse: 'collapse' }}>{data.other_name}</td>
            {/* <td style={{ border: '1px solid black', borderCollapse: 'collapse' }}>{data.i_subject}</td> */}
            <td style={{ border: '1px solid black', borderCollapse: 'collapse' }}>{data.other_obtmarks}</td>
            <td style={{ border: '1px solid black', borderCollapse: 'collapse' }}>{data.other_maxmarks}</td>
            <td style={{ border: '1px solid black', borderCollapse: 'collapse' }}>{data.other_percentage}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
);

export default EducationDetails